export default "__VITE_ASSET__Do4Dlnlp__"